import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-ketto-assured-v2',
  templateUrl: './ketto-assured-v2.component.html',
  styleUrls: ['./ketto-assured-v2.component.scss']
})
export class KettoAssuredV2Component implements OnInit {

  @Input() theme = 'theme_v1';

  constructor() { }

  ngOnInit(): void {
  }

}
